module.exports = __webpack_public_path__ + "img/headphones.f45831c2.svg";